module.exports = __webpack_public_path__ + "studio-bg.png?867abed17359d8e32cc20f08c057b5ee";